/*
 * @message: 路由配置
 * @Author: cjc
 * @since: 2019-11-26 12:10:14
 * @lastTime: 2019-12-17 12:03:18
 * @LastAuthor: cjc
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const index = () => import('@/views/index')
const subpage = () => import('@/views/subpage')
const details = () => import('@/views/details')
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/notice',
      name: '游戏公告',
      component: subpage,
      props: { type: 'notice', name: '游戏公告' }
    },
    {
      path: '/strategy',
      name: '游戏攻略',
      component: subpage,
      props: { type: 'strategy', name: '游戏攻略' }
    },
    {
      path: '/details',
      name: 'details',
      component: details
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js